import { render, staticRenderFns } from "./PerformaMitra.vue?vue&type=template&id=20adf94e&"
import script from "./PerformaMitra.vue?vue&type=script&lang=js&"
export * from "./PerformaMitra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports